module.exports = __webpack_public_path__ + "static/img/3662_phase_function_Paper_Points.dfdb9f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3662_phase_function_Paper_Points.png
// module id = BRD2
// module chunks = 0